"use client";
import type { ReactElement, RefObject } from "react";
import type { MotionValue } from "framer-motion";
import { CwitnessHeroCard } from "./CwitnessHeroCard";
import { CwitnessParallaxTextCard } from "./CwitnessParallaxTextCard";
import { buildLeftColumnStyle } from "./styles";
import type { ParallaxTextSpacing } from "./types";
interface CwitnessLeftColumnProps {
    isCompact: boolean;
    isMobile: boolean;
    leftColumnRef: RefObject<HTMLDivElement | null>;
    parallaxContentRef: RefObject<HTMLDivElement | null>;
    parallaxScrollRef: RefObject<HTMLDivElement | null>;
    parallaxTextSize: number;
    parallaxTextSpacing: ParallaxTextSpacing;
    parallaxTextY: MotionValue<number>;
    vh: number;
}
export function CwitnessLeftColumn({ isCompact, isMobile, leftColumnRef, parallaxContentRef, parallaxScrollRef, parallaxTextSize, parallaxTextSpacing, parallaxTextY, vh, }: CwitnessLeftColumnProps): ReactElement {
    const leftColumnStyle = buildLeftColumnStyle({ isMobile, vh });
    return (
      <div ref={leftColumnRef} style={leftColumnStyle}>
        <CwitnessHeroCard isCompact={isCompact} isMobile={isMobile}/>

        <CwitnessParallaxTextCard contentRef={parallaxContentRef} isMobile={isMobile} parallaxTextSize={parallaxTextSize} scrollRef={parallaxScrollRef} textBottomSpacing={parallaxTextSpacing.textBottomSpacing} textTopSpacing={parallaxTextSpacing.textTopSpacing} textY={parallaxTextY}/>
      </div>
    );
}
